import myShopClient from './nearlive';

export async function requestSetup(id, content) {
	const client = await myShopClient();
	const { data } = await client.post(`/api/channels/${id}/setup-request`, { content });
	return data;
}
